import(/* webpackMode: "eager" */ "/tmp/8def7ec994c039d/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8def7ec994c039d/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8def7ec994c039d/src/app/metrics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8def7ec994c039d/src/components/ClientInit/ClientInit.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def7ec994c039d/src/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def7ec994c039d/src/styles/global.scss");
